import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import HealthConvention from "./layouts/HealthConvention";
import { Routes, Route} from "react-router-dom";

import { MaterialUIControllerProvider } from "context";

import { Provider } from "react-redux";
import store from "./redux/store";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <Routes>
          <Route path="/Business&Health2025" element={<HealthConvention />} />
        </Routes>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>
  //</React.StrictMode>
);
